import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import NoData from "../../../../components/noData/Nodata";
import CustomTable from "../../../../components/table/CustomTable";
import TileBox from "../../../../components/tile/TileBox";
import StatusChip from "../../../../elements/StatusChip";
import { FileDownloadOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useStyles } from "../style";

const priorityMap = {
  CRITICAL: 1,
  HIGH: 2,
  MEDIUM: 3,
  LOW: 4,
  INFORMATIONAL: 5,
};

const columns = [
  {
    field: "title",
    label: "Title",
    align: "left",
    render: (row) => (
      <Tooltip arrow title={row.description}>
        {row.title}
      </Tooltip>
    ),
  },
  { field: "age", align: "left", label: "Age" },
  {
    field: "severity",
    label: "Severity",
    sortComparator: (order, orderBy) => {
      return order === "desc"
        ? (a, b) => priorityMap[a[orderBy]] - priorityMap[b[orderBy]]
        : (a, b) => priorityMap[b[orderBy]] - priorityMap[a[orderBy]];
    },
    render: (row) => {
      return <StatusChip status={row?.severity} />;
    },
  },
  { field: "region", label: "Region" },
  { field: "accountId", align: "left", label: "Account" },
];

const VulnerabilitiesPassDueDetails = ({ data, handleDownload }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const handleDownloadData = async () => {
    setLoading(true);
    await handleDownload(() => setLoading(false));
  };
  return (
    <TileBox title={"Vulnerabilities Details "}>
      {data.length > 0 ? (
        <>
          <CustomTable
            columns={columns}
            data={data}
            pagination={true}
            headerClass={classes.tableHeaderClass}
            variant="secondary"
          />
          <Box
            sx={{ marginTop: "12px", display: "flex", justifyContent: "end" }}
          >
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <FileDownloadOutlined />
                )
              }
              variant="contained"
              color="primary"
              onClick={handleDownloadData}
            >
              Download
            </Button>
          </Box>
        </>
      ) : (
        <NoData />
      )}
    </TileBox>
  );
};

export default VulnerabilitiesPassDueDetails;
